/**
 * Builds the link to the chat composition page in "edit existing message" mode, for a scheduled
 * message or draft whose room has no inbox thread to open yet.
 *
 * @param params.roomId - Room the message belongs to, so editing reuses it rather than creating another
 * @param params.draftId - The scheduled message or draft being edited
 * @param params.enduserId - Recipient, to seed the panel's recipient field
 * @param params.subject - Room title, to seed the panel's subject field
 */
export const buildChatCompositionEditLink = ({
  roomId,
  draftId,
  enduserId,
  subject,
}: {
  roomId: string;
  draftId: string;
  enduserId?: string;
  subject?: string;
}): string => {
  const params = new URLSearchParams({ roomId, draftId });
  if (enduserId) params.set("enduserId", enduserId);
  if (subject) params.set("subject", subject);

  return `/messaging/inbox/chat/new?${params.toString()}`;
};
